import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfdc0db0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订舱信息", -1))
const _hoisted_2 = { class: "form-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_order_form_company_business_card = _resolveComponent("order-form-company-business-card")!
  const _component_order_form_products_summary = _resolveComponent("order-form-products-summary")!
  const _component_order_form_container = _resolveComponent("order-form-container")!
  const _component_order_form_cost = _resolveComponent("order-form-cost")!
  const _component_order_form_lading_bill = _resolveComponent("order-form-lading-bill")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_company_business_card_form = _resolveComponent("company-business-card-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_order_supplier = _resolveComponent("order-supplier")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_miezz_card, {
      fix: true,
      "bottom-buttons": _ctx.buttons,
      onHandleFooterButtonClick: _ctx.handleClick
    }, {
      headerLeft: _withCtx(() => [
        _hoisted_1,
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              style: {"display":"inline-block","margin":"0px 0px 0px 20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.form.Data.HasPartBill,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.HasPartBill) = $event)),
                  options: _ctx.hasPartBillOptions,
                  boolean: true,
                  disabled: 
            _ctx.detail && _ctx.detail.StowageOrder && (_ctx.detail.PoolCount ?? 0) > 1
          ,
                  clearable: false,
                  onHandleChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChangeHasPartBill()))
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _ctx.form.Data,
              ref: "ruleForm",
              rules: _ctx.form.Rules,
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_order_form_company_business_card, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form) = $event)),
                    scene: "Booking",
                    red: _ctx.addDeparturePortBooking
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "业务类型",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail?.StowageOrder)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_el_form_item, {
                                  prop: "TransportDirection",
                                  class: "direction"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_miezz_select, {
                                      modelValue: _ctx.form.Data.TransportDirection,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.TransportDirection) = $event)),
                                      options: _ctx.EnumTransportDirectionOption,
                                      disabled: 
                      !(_ctx.detail?.PreStowageOrder && _ctx.detail.PoolCount == 0)
                    
                                    }, null, 8, ["modelValue", "options", "disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  prop: "TransportType",
                                  class: "type"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_miezz_select, {
                                      modelValue: _ctx.form.Data.TransportType,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.TransportType) = $event)),
                                      options: _ctx.EnumTransportTypeOption,
                                      disabled: 
                      !(_ctx.detail?.PreStowageOrder && _ctx.detail.PoolCount == 0)
                    
                                    }, null, 8, ["modelValue", "options", "disabled"])
                                  ]),
                                  _: 1
                                }),
                                (
                    _ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea ||
                    _ctx.form.Data.TransportType == _ctx.EnumTransportType.Railway
                  )
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      prop: "TransportContainerLoad",
                                      class: "containerLoad"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_select, {
                                          modelValue: _ctx.form.Data.TransportContainerLoad,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.TransportContainerLoad) = $event)),
                                          options: 
                      _ctx.EnumTransportContainerLoadOption.filter(
                        (it) => it.Value != 3
                      )
                    
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.type), 1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "订舱代理",
                        prop: "SupplierCompanyLabel"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.Data.SupplierCompanyLabel,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.SupplierCompanyLabel) = $event)),
                            style: {"display":"none"}
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("a", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSupplierClick())),
                            href: "javascript:void",
                            style: {"color":"#fe995b","text-decoration":"none"}
                          }, _toDisplayString(_ctx.form.Data.SupplierCompanyLabel &&
                  _ctx.form.Data.SupplierCompanyContactLabel
                    ? `${_ctx.form.Data.SupplierCompanyLabel ?? "暂无数据"}/${
                        _ctx.form.Data.SupplierCompanyContactLabel ?? "暂无数据"
                      }`
                    : _ctx.form.Data.SupplierCompanyLabel
                    ? _ctx.form.Data.SupplierCompanyLabel
                    : "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of  Loading/装货港",
                        prop: "LoadingPortId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.LoadingPortId,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.LoadingPortId) = $event)),
                            label: _ctx.form.Data.LoadingPortLabel,
                            "onUpdate:label": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.Data.LoadingPortLabel) = $event)),
                            options: _ctx.loadingPorts,
                            remote: true,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加',
                            remoteMethod: _ctx.getLoadingPorts,
                            red: _ctx.addDeparturePortBooking,
                            onHandleChange: _cache[9] || (_cache[9] = ($event: any) => (
                  _ctx.handleChangePort(
                    _ctx.form.Data.LoadingPortId,
                    _ctx.detail?.LoadingPortId
                  )
                ))
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Discharge/卸货港",
                        prop: "DischargePortId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.DischargePortId,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Data.DischargePortId) = $event)),
                            label: _ctx.form.Data.DischargePortLabel,
                            "onUpdate:label": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.Data.DischargePortLabel) = $event)),
                            options: _ctx.dischargePorts,
                            remote: true,
                            remoteMethod: _ctx.getDischargePorts,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加'
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Delivery/目的港",
                        prop: "DeliveryPortId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.DeliveryPortId,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.Data.DeliveryPortId) = $event)),
                            label: _ctx.form.Data.DeliveryPortLabel,
                            "onUpdate:label": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.DeliveryPortLabel) = $event)),
                            options: _ctx.deliveryPorts,
                            remote: true,
                            remoteMethod: _ctx.getDeliveryPorts,
                            red: _ctx.addDeparturePortBooking,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加',
                            onHandleChange: _cache[14] || (_cache[14] = ($event: any) => (
                  _ctx.handleChangePort(
                    _ctx.form.Data.DeliveryPortId,
                    _ctx.detail?.DeliveryPortId
                  )
                ))
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Place of Delivery/交货地点",
                        prop: "DeliveryPlaceLabel"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            ref: "ref-delivery-place",
                            modelValue: _ctx.form.Data.DeliveryPlaceLabel,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.Data.DeliveryPlaceLabel) = $event)),
                            "fetch-suggestions": _ctx.getDeliveryPlaces,
                            "trigger-on-focus": true,
                            clearable: "",
                            valueKey: "FullName",
                            onHandleSelect: _ctx.handleSelectDeliveryPlace
                          }, null, 8, ["modelValue", "fetch-suggestions", "onHandleSelect"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "详细地址",
                        prop: "DeliveryPlaceAddress"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.DeliveryPlaceAddress,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.Data.DeliveryPlaceAddress) = $event)),
                            type: "textarea",
                            rows: 3,
                            resize: "none",
                            trim: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "承运人",
                        prop: "CarrierId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.CarrierId,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.Data.CarrierId) = $event)),
                            label: _ctx.form.Data.CarrierLabel,
                            "onUpdate:label": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.Data.CarrierLabel) = $event)),
                            options: _ctx.carriers,
                            remote: true,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加',
                            remoteMethod: _ctx.getCarriers,
                            onVisibleChange: _cache[19] || (_cache[19] = 
                  (s) => {
                    if (s) _ctx.getCarriers();
                  }
                )
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "渠道",
                        prop: "TransportChannelId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.TransportChannelId,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.Data.TransportChannelId) = $event)),
                            label: _ctx.form.Data.TransportChannelLabel,
                            "onUpdate:label": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.Data.TransportChannelLabel) = $event)),
                            options: _ctx.channels,
                            remote: true,
                            remoteMethod: _ctx.getChannels,
                            onVisibleChange: _cache[22] || (_cache[22] = 
                  (s) => {
                    if (s) _ctx.getChannels();
                  }
                )
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "合约号",
                        prop: "ContractNo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.ContractNo,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.Data.ContractNo) = $event)),
                            upperCase: true,
                            trimAll: true
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "船名",
                            prop: "ShipName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.ShipName,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.Data.ShipName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "航次",
                            prop: "VoyageNumber"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.VoyageNumber,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.Data.VoyageNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Air)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "航班",
                            prop: "Flight"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.Flight,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.Data.Flight) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Railway)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: "班次",
                            prop: "RailwayNumber"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.RailwayNumber,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.Data.RailwayNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "装货港ETD",
                        prop: "EstimatedDepartureDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.EstimatedDepartureDate,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.Data.EstimatedDepartureDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBooking ? ' red' : ''
                }`)
                          }, null, 8, ["modelValue", "class"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "目的港ETA",
                        prop: "EstimatedArrivalDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.EstimatedArrivalDate,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.Data.EstimatedArrivalDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运费支付方式",
                        prop: "TransportPaymentType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.TransportPaymentType,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.Data.TransportPaymentType) = $event)),
                            options: _ctx.EnumTransportPaymentTypeOption
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运输类型",
                        prop: "GoodsTransportType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.GoodsTransportType,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.Data.GoodsTransportType) = $event)),
                            options: _ctx.EnumGoodsTransportTypeOption
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "备注",
                        prop: "Remark"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.Remark,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.Data.Remark) = $event)),
                            type: "textarea",
                            rows: 5,
                            resize: "none",
                            trim: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["form", "red"]),
                  _createVNode(_component_order_form_products_summary, {
                    reds: 
            _ctx.addDeparturePortBooking
              ? [
                  'MarksNotes',
                  'PackagesNumber',
                  'PackagesKind',
                  'GoodsDescription',
                  'GrossWeight',
                  'Volume',
                ]
              : []
          ,
                    form: _ctx.form,
                    "onUpdate:form": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form) = $event))
                  }, null, 8, ["reds", "form"]),
                  (
            _ctx.form.Data.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          )
                    ? (_openBlock(), _createBlock(_component_order_form_container, {
                        key: 0,
                        form: _ctx.form,
                        "onUpdate:form": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form) = $event)),
                        disabledAdd: _ctx.detail?.StowageOrder,
                        disabledQuantity: _ctx.detail?.StowageOrder,
                        red: _ctx.addDeparturePortBooking,
                        containerTypes: _ctx.containerTypes
                      }, null, 8, ["form", "disabledAdd", "disabledQuantity", "red", "containerTypes"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_order_form_cost, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form) = $event)),
                    currencySystem: _ctx.currencySystem,
                    currencySystems: _ctx.currencySystems
                  }, null, 8, ["form", "currencySystem", "currencySystems"]),
                  _createVNode(_component_order_form_lading_bill, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form) = $event))
                  }, null, 8, ["form"])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["bottom-buttons", "onHandleFooterButtonClick"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBusinessCard,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.modalBusinessCard) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_company_business_card_form, {
          modelValue: _ctx.modalBusinessCard,
          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.modalBusinessCard) = $event)),
          id: _ctx.businessCardId,
          companyId: 
        _ctx.form.Data.HasPartBill
          ? _ctx.logier?.ServiceProviderCompanyId
          : _ctx.detail?.ClientCompanyId
      ,
          parentId: _ctx.businessCardParentId,
          area: _ctx.businessCardArea,
          type: _ctx.businessCardType,
          content: _ctx.businessCardContent,
          onHandleSubmit: _ctx.handleSubmitBusinessCard
        }, null, 8, ["modelValue", "id", "companyId", "parentId", "area", "type", "content", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_order_supplier, {
      ref: "ref-order-supplier",
      show: _ctx.showSupplier,
      canEdit: true,
      onHandleSave: _ctx.handleSaveSupplier
    }, null, 8, ["show", "onHandleSave"])
  ], 64))
}